import { Box, Fab, Grid, IconButton, Typography } from '@mui/material';
import { ISifRowsCodesStatus } from '../../types';
import { FormattedMessage } from 'react-intl';
import { Close, ExpandLess, ExpandMore } from '@mui/icons-material';
import { getFormattedSifRowsCodes } from '../AlertBox/assets';
import { useState } from 'react';
import { getFormattedCode } from '../AlertBox/utils';

export type ImportResultCodesProps = {
    sifRowsCodesStatus: ISifRowsCodesStatus;
    onClose: () => void;
};

export const ImportResultCodes = ({ sifRowsCodesStatus, onClose }: ImportResultCodesProps) => {
    const [collapseSections, setCollapseSections] = useState<Record<string, boolean>>(
        getFormattedSifRowsCodes(sifRowsCodesStatus).reduce((acc, el) => ({ ...acc, [el.title]: false }), {})
    );

    const handleUpdateCollapse = (title: string) => () => {
        setCollapseSections((prev) => ({ ...prev, [title]: !prev[title] }));
    };
    return (
        <Grid item xs="auto" height="100%">
            <Grid container justifyContent="space-between" width="400px" height="100%" borderRadius="12px" flexWrap="nowrap">
                <Grid item xs="auto">
                    <Box
                        id="import-result-panel"
                        component={Grid}
                        container
                        sx={{
                            width: '340px',
                            height: '-webkit-fill-available',
                            p: '12px',
                            borderRadius: '8px',
                            background: 'white',
                            border: 'solid 1px #D9D9D9'
                        }}
                    >
                        <Grid item xs={12}>
                            <Typography color="#37326E" sx={{ my: 1 }} fontWeight={700} textTransform="capitalize" fontSize="16px">
                                <FormattedMessage id="importResult" />
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ height: 'calc(100% - 45px)', overflow: 'auto' }}>
                            {getFormattedSifRowsCodes(sifRowsCodesStatus).map(({ title, codes }) => (
                                <Box
                                    key={title}
                                    component={Grid}
                                    container
                                    direction="column"
                                    wrap="nowrap"
                                    className="result-codes-box"
                                    sx={{
                                        width: '100%',
                                        height: collapseSections[title] ? '35px' : '380px',
                                        borderRadius: '8px',
                                        mb: '6px',
                                        border: 'solid 1px #D9D9D9',
                                        background: '#F5F6F7'
                                    }}
                                >
                                    <Grid item xs="auto">
                                        <Box
                                            component={Grid}
                                            container
                                            alignItems="center"
                                            sx={{ width: '100%', height: '32px', px: '6px' }}
                                        >
                                            <Grid item xs>
                                                <Typography fontSize="14px" fontWeight={700} color="#858585">
                                                    {title}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs="auto">
                                                <IconButton
                                                    sx={{ p: 0 }}
                                                    onClick={handleUpdateCollapse(title)}
                                                    disableRipple
                                                    disableFocusRipple
                                                    disableTouchRipple
                                                >
                                                    {collapseSections[title] ? (
                                                        <ExpandLess htmlColor="#858585" />
                                                    ) : (
                                                        <ExpandMore htmlColor="#858585" />
                                                    )}
                                                </IconButton>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    {!collapseSections[title] && (
                                        <Grid item xs sx={{ p: '6px', borderRadius: '0 0 8px 8px', overflow: 'auto', background: 'white' }}>
                                            <Box component="ul" sx={{ pl: 2 }}>
                                                {codes?.map((code, index) => (
                                                    <Typography component="li" key={index} sx={{ mb: 0.5 }}>
                                                        {getFormattedCode(code)}
                                                    </Typography>
                                                ))}
                                            </Box>
                                        </Grid>
                                    )}
                                </Box>
                            ))}
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs="auto">
                    <Box
                        id="import-result-panel-actions"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '52px',
                            pt: '6px',
                            height: '-webkit-fill-available',
                            background: '#F5F6F7'
                        }}
                    >
                        <Fab
                            onClick={onClose}
                            sx={{
                                width: 40,
                                height: 40,
                                boxShadow: 'none',
                                background: 'white',
                                '& svg': { color: '#858585' }
                            }}
                        >
                            <Close />
                        </Fab>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};
